export default __webpack_public_path__ + "static/media/fold.7dc32b0e.png";